export default __webpack_public_path__ + "static/media/card-m-service.866ec434.png";